<template>
  <span>
  </span>
</template>

<script>
export default {
  computed: {
    firstName () {
      return this.$store.getters['user/user'].firstName
    },
    lastName () {
      return this.$store.getters['user/user'].lastName
    },
    email () {
      return this.$store.getters['user/user'].email
    }
  },

  mounted () {
    // Intercom('boot', {  
    //   app_id: 'f5hokpxm'
    // })
    // setInterval(() => {
    //   Intercom('hide')
    // }, 3000)
    // Intercom('update', {
    //   hide_default_launcher: true
    // })
  },
  watch: {
    firstName () {
      Intercom('boot', {
        app_id: 'f5hokpxm',
        name: this.firstName + ' ' + this.lastName,
        email: this.email
      })
    }
  }
}
</script>